export default class ProjectUserDetailsService {
  constructor (Api) {
    this.api = Api;
  }

  getUserDetails ({ values }) {
    return this.api.post('gdpr/user', values);
  }
}
